<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Non-refundable Fee and Code of Ethics Acknowledgement
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <p class="mb-2">
        Please check each box below indicating that you agree with each term.
      </p>
      <d-field :rules="{required: { allowFalse: false }}" name="Pledge of Ethics Acceptance">
        <d-checkbox v-model="pledgeOfEthics">
          We understand and accept that QCP annual license renewal fees are NON-REFUNDABLE, and agree to honor and abide by the following Pledge of Ethics:
        </d-checkbox>
      </d-field>

      <p class="ml-10 mb-10 italic">
        We are committed to elevating the level of quality in the woodwork industry and we support the goals of the AWI Quality Certification Corporation.
        We agree to abide by the rules and regulations as outlined in the Quality Certification Program Policies and with the Architectural Woodwork Institute's quality standards.
        We will conduct ourselves in a manner that is a credit to the industry.
      </p>
      <d-field :rules="{required: { allowFalse: false }}" name="Program Policies Acceptance">
        <d-checkbox v-model="programPolicies">
          I agree to abide by the program policies as stated in the current edition of the <a href="https://awiqcp.org/policies" target="_blank" rel="noopener noreferrer">AWI Quality Certification Program Policies Handbook</a> and any revisions or supplements thereto.
        </d-checkbox>
      </d-field>
      <d-field :rules="{required: { allowFalse: false }}" name="Late Fee Acceptance">
        <d-checkbox v-model="lateFeeAcceptance">
          I understand that per program policies, renewal payments postmarked after Dec. 31 will be subject to a $300 late fee.
        </d-checkbox>
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn type="submit" class="mx-5 md:mx-0">
          Proceed to Renewal
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { RENEWAL_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('renewalForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['pledgeOfEthics', 'programPolicies', 'lateFeeAcceptance'],
        module: 'renewalForm',
        base: 'formFields',
        mutation: RENEWAL_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToNextPage',
      ]),
    },
  };
</script>